<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions('auth', ['verifyTemporaryToken']),
    async openDashboard() {
      try {
        await this.verifyTemporaryToken({ token: this.$route.query.token });
        if (this.$route.query.redirectPath) {
          const redirectPath = this.$route.query.redirectPath;
          // Everything except the hand-off params travels on to the target route,
          // so a deep link can carry its own context (e.g. a scenario interview).
          const forwardedQuery = { ...this.$route.query };
          delete forwardedQuery.token;
          delete forwardedQuery.redirectPath;
          this.$router.push({ name: redirectPath, query: forwardedQuery });
        } else {
          this.$router.push({ name: 'student-dashboard' });
        }
      } catch (e) {
        //
      }
    },
  },
  async mounted() {
    setTimeout(() => {
      if (this.$route.query.token) {
        this.openDashboard(this.$route.query.token);
      }
    }, 200);
  },
};
</script>
